// AUTO-GENERATED — do not edit. Run `pnpm build` in packages/domain-data.
// Source: business/ishvaram/data/domain/astrology/tarot.yaml

import type { TarotReferenceCard } from "./types";

export const majorArcanaTarotCards = [
  {
    image_description: "A traveler at a cliff edge with a small bundle, looking upward",
    id: 0,
    name_en: "The Fool",
    name_hi: "मूर्ख",
    vedic_name: "Aarambh (The Beginning)",
    vedic_parallel: "Like Arjuna before the Gita — standing at the threshold of transformation",
    upright: {
      keywords: ["new beginnings", "innocence", "spontaneity", "free spirit"],
      meaning: "A fresh start awaits. Trust the journey even without knowing the destination.",
      advice: "Take the leap. The universe catches those who trust.",
    },
    reversed: {
      keywords: ["recklessness", "risk", "holding back", "foolishness"],
      meaning: "Hesitation or reckless action. Check if fear or ego is driving your choice.",
      advice: "Pause before jumping. Not every impulse is intuition.",
    },
    planet: "uranus",
    vedic_graha: "rahu",
    element: "air",
    arcana: "major",
    suit: null,
  },
  {
    image_description:
      "A figure with one hand raised to sky, one pointing to earth, tools before him",
    id: 1,
    name_en: "The Magician",
    name_hi: "जादूगर",
    vedic_name: "Siddha (The Accomplished)",
    vedic_parallel: "Like Vishwakarma, the divine architect — all tools of creation at hand",
    upright: {
      keywords: ["willpower", "manifestation", "skill", "resourcefulness"],
      meaning: "You have every resource you need. Channel your will and the elements align.",
      advice: "Act with focus. Your intention shapes reality.",
    },
    reversed: {
      keywords: ["manipulation", "trickery", "wasted talent", "deception"],
      meaning: "Talent without integrity leads nowhere. Are you using your gifts wisely?",
      advice: "Align your actions with dharma, not just desire.",
    },
    planet: "mercury",
    vedic_graha: "budh",
    element: "air",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A veiled woman seated between two pillars, a crescent moon at her feet",
    id: 2,
    name_en: "The High Priestess",
    name_hi: "महापुजारिन",
    vedic_name: "Yogini (The Inner Knower)",
    vedic_parallel: "Like Saraswati in meditation — the wisdom that comes from stillness",
    upright: {
      keywords: ["intuition", "mystery", "inner knowledge", "subconscious"],
      meaning: "The answer lies within. Tradition says stillness reveals what action cannot.",
      advice: "Trust your inner voice. Not everything needs to be spoken.",
    },
    reversed: {
      keywords: ["secrets", "withdrawal", "silence", "disconnection"],
      meaning: "You may be ignoring your intuition or hiding from a truth you already know.",
      advice: "Sit quietly. The clarity you seek is already present.",
    },
    planet: "moon",
    vedic_graha: "chandra",
    element: "water",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A crowned woman seated in a lush garden, surrounded by grain and flowers",
    id: 3,
    name_en: "The Empress",
    name_hi: "साम्राज्ञी",
    vedic_name: "Devi (The Mother)",
    vedic_parallel: "Like Annapurna — the goddess of abundance who nourishes all creation",
    upright: {
      keywords: ["abundance", "fertility", "nature", "nurturing", "beauty"],
      meaning: "A season of growth and abundance. Creation flows naturally from you.",
      advice: "Nurture what you have planted. The harvest is approaching.",
    },
    reversed: {
      keywords: ["dependence", "stagnation", "creative block", "neglect"],
      meaning: "You may be neglecting self-care or blocking your own creative flow.",
      advice: "Reconnect with nature and your body. Abundance starts with self-nourishment.",
    },
    planet: "venus",
    vedic_graha: "shukra",
    element: "earth",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A king on a stone throne, holding a scepter, mountains behind him",
    id: 4,
    name_en: "The Emperor",
    name_hi: "सम्राट",
    vedic_name: "Chakravartin (The Sovereign)",
    vedic_parallel: "Like Raja Rama — righteous authority that protects through dharma",
    upright: {
      keywords: ["authority", "structure", "stability", "discipline", "leadership"],
      meaning: "Structure and discipline serve you now. Lead with fairness and firmness.",
      advice: "Build your foundation. Order creates the space for greatness.",
    },
    reversed: {
      keywords: ["tyranny", "rigidity", "domination", "lack of discipline"],
      meaning: "Authority without compassion becomes oppression. Flexibility is also strength.",
      advice: "Examine where control has replaced care.",
    },
    planet: "mars",
    vedic_graha: "mangal",
    element: "fire",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A robed spiritual teacher between two pillars, two students kneeling",
    id: 5,
    name_en: "The Hierophant",
    name_hi: "धर्मगुरु",
    vedic_name: "Guru (The Teacher)",
    vedic_parallel: "Like Guru Brihaspati — the one who transmits sacred knowledge through lineage",
    upright: {
      keywords: ["tradition", "spiritual guidance", "conformity", "education", "wisdom"],
      meaning: "Seek guidance from tradition and those who have walked the path before you.",
      advice: "A teacher or teaching is ready to appear. Be open to learning.",
    },
    reversed: {
      keywords: ["rebellion", "unorthodox", "restriction", "challenging status quo"],
      meaning: "Blind adherence to tradition may be limiting you. Question, but with respect.",
      advice: "Find your own truth, but do not discard ancient wisdom carelessly.",
    },
    planet: "jupiter",
    vedic_graha: "guru",
    element: "earth",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "Two figures beneath a radiant angel, standing in a garden of choice",
    id: 6,
    name_en: "The Lovers",
    name_hi: "प्रेमी",
    vedic_name: "Mithuna (The Union)",
    vedic_parallel: "Like Shiva and Shakti — the sacred union of opposites that creates wholeness",
    upright: {
      keywords: ["love", "harmony", "choices", "alignment", "partnership"],
      meaning:
        "A meaningful choice or union is before you. Follow what aligns your heart and mind.",
      advice: "Choose from love, not fear. True union begins with inner harmony.",
    },
    reversed: {
      keywords: ["disharmony", "imbalance", "misalignment", "temptation"],
      meaning: "A relationship or choice feels off. Examine where values conflict.",
      advice: "Realign before committing. Harmony cannot be forced.",
    },
    planet: "venus",
    vedic_graha: "shukra",
    element: "air",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A warrior in a chariot drawn by two sphinxes, a canopy of stars above",
    id: 7,
    name_en: "The Chariot",
    name_hi: "रथ",
    vedic_name: "Vijaya Ratha (The Victory Chariot)",
    vedic_parallel: "Like Krishna steering Arjuna's chariot — willpower guided by divine wisdom",
    upright: {
      keywords: ["victory", "determination", "willpower", "triumph", "control"],
      meaning: "Victory through focused will. The chariot moves when purpose is clear.",
      advice: "Harness your opposing forces. Directed energy conquers all obstacles.",
    },
    reversed: {
      keywords: ["aggression", "lack of direction", "defeat", "scattered energy"],
      meaning: "Force without direction leads to defeat. Are you charging ahead blindly?",
      advice: "Pause to steer before you accelerate.",
    },
    planet: "moon",
    vedic_graha: "chandra",
    element: "water",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A woman gently holding open the jaws of a lion, an infinity symbol above",
    id: 8,
    name_en: "Strength",
    name_hi: "शक्ति",
    vedic_name: "Shakti (Inner Power)",
    vedic_parallel: "Like Durga taming the lion — courage through compassion, not brute force",
    upright: {
      keywords: ["courage", "inner strength", "patience", "compassion", "resilience"],
      meaning: "True strength is gentle. Patient endurance overcomes what force cannot.",
      advice: "Meet challenges with composure. Your calm is your greatest weapon.",
    },
    reversed: {
      keywords: ["self-doubt", "weakness", "insecurity", "raw emotion"],
      meaning: "Inner doubt is louder than outer obstacles. Where has your confidence gone?",
      advice: "Reconnect with your core. Strength returns when self-trust is restored.",
    },
    planet: "sun",
    vedic_graha: "surya",
    element: "fire",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A robed figure on a mountain peak, holding a lantern, looking down",
    id: 9,
    name_en: "The Hermit",
    name_hi: "तपस्वी",
    vedic_name: "Tapasvi (The Ascetic)",
    vedic_parallel: "Like Vyasa in the cave — withdrawing from the world to see the truth within",
    upright: {
      keywords: ["solitude", "introspection", "guidance", "inner light", "wisdom"],
      meaning: "A time for withdrawal and reflection. The answers are found in silence.",
      advice: "Step away from noise. Your inner lamp illuminates the path.",
    },
    reversed: {
      keywords: ["isolation", "loneliness", "withdrawal", "lost direction"],
      meaning:
        "Solitude has become isolation. You may be hiding from life instead of seeking truth.",
      advice: "Seek connection. Even hermits eventually share their wisdom.",
    },
    planet: "mercury",
    vedic_graha: "budh",
    element: "earth",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A great wheel with figures rising and falling, a sphinx at the top",
    id: 10,
    name_en: "Wheel of Fortune",
    name_hi: "भाग्यचक्र",
    vedic_name: "Kalachakra (The Wheel of Time)",
    vedic_parallel: "Like the cycle of yugas — what rises must fall, what falls must rise again",
    upright: {
      keywords: ["destiny", "cycles", "turning point", "luck", "karma"],
      meaning: "The wheel turns. A karmic shift brings new opportunities and circumstances.",
      advice: "Accept the change. Karma delivers what your actions have earned.",
    },
    reversed: {
      keywords: ["bad luck", "resistance to change", "broken cycle", "setback"],
      meaning: "Resisting the natural cycle only prolongs suffering. Let the wheel turn.",
      advice: "Release your grip. What seems like loss may be the universe rearranging.",
    },
    planet: "jupiter",
    vedic_graha: "guru",
    element: "fire",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A crowned figure holding scales and a sword, seated between pillars",
    id: 11,
    name_en: "Justice",
    name_hi: "न्याय",
    vedic_name: "Dharma Nyaya (Cosmic Justice)",
    vedic_parallel: "Like Yama, the lord of dharma — every action has its precise consequence",
    upright: {
      keywords: ["fairness", "truth", "law", "cause and effect", "accountability"],
      meaning: "Truth and fairness prevail. The consequences of past actions arrive now.",
      advice: "Act with integrity. Karma is precise — it misses nothing.",
    },
    reversed: {
      keywords: ["injustice", "dishonesty", "imbalance", "lack of accountability"],
      meaning:
        "Something is out of balance. Dishonesty or avoidance delays but does not escape justice.",
      advice: "Correct the imbalance before it corrects itself.",
    },
    planet: "venus",
    vedic_graha: "shukra",
    element: "air",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A figure suspended upside-down from a tree, expression serene",
    id: 12,
    name_en: "The Hanged Man",
    name_hi: "लटकता हुआ",
    vedic_name: "Viparita (The Reversal)",
    vedic_parallel: "Like the Vamana avatar — seeing the universe from an inverted perspective",
    upright: {
      keywords: ["surrender", "new perspective", "pause", "sacrifice", "letting go"],
      meaning: "Surrender brings clarity. Sometimes progress requires standing still.",
      advice: "Let go of control. The view changes when you stop struggling.",
    },
    reversed: {
      keywords: ["stalling", "resistance", "needless sacrifice", "indecision"],
      meaning: "You are delaying for no reason, or sacrificing without purpose.",
      advice: "If the pause has served its purpose, it is time to move.",
    },
    planet: "neptune",
    vedic_graha: "ketu",
    element: "water",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A skeletal figure on a white horse, a rising sun in the distance",
    id: 13,
    name_en: "Death",
    name_hi: "मृत्यु",
    vedic_name: "Pralaya (The Dissolution)",
    vedic_parallel: "Like Shiva as Mahakala — destruction that clears the ground for new creation",
    upright: {
      keywords: ["transformation", "ending", "transition", "letting go", "renewal"],
      meaning: "An ending that makes space for rebirth. What dies was already complete.",
      advice: "Release what has served its purpose. New life waits on the other side.",
    },
    reversed: {
      keywords: ["resistance to change", "stagnation", "fear of endings", "decay"],
      meaning: "Clinging to what is already over. The refusal to let go creates suffering.",
      advice: "Accept the ending with grace. Resistance only prolongs the pain.",
    },
    planet: "pluto",
    vedic_graha: "ketu",
    element: "water",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "An angel pouring water between two cups, one foot on land, one in water",
    id: 14,
    name_en: "Temperance",
    name_hi: "संतुलन",
    vedic_name: "Samatva (Equanimity)",
    vedic_parallel: "Like the middle path of Buddha — balance between extremes brings peace",
    upright: {
      keywords: ["balance", "moderation", "patience", "harmony", "purpose"],
      meaning: "Harmony through balance. Mix your energies with patience and purpose.",
      advice: "Find the middle path. Excess in any direction creates imbalance.",
    },
    reversed: {
      keywords: ["imbalance", "excess", "impatience", "misalignment"],
      meaning: "You have gone too far in one direction. Recalibrate before it costs you.",
      advice: "Step back and restore equilibrium. Healing comes from balance.",
    },
    planet: "jupiter",
    vedic_graha: "guru",
    element: "fire",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A horned figure on a pedestal, two chained figures below who could leave",
    id: 15,
    name_en: "The Devil",
    name_hi: "असुर",
    vedic_name: "Maya Bandhan (The Bondage of Illusion)",
    vedic_parallel: "Like Ravana's golden Lanka — attachment to material splendor that imprisons",
    upright: {
      keywords: ["bondage", "materialism", "addiction", "temptation", "shadow self"],
      meaning:
        "Something holds you captive — habit, desire, or fear. The chains are of your own making.",
      advice: "Recognize the illusion. Freedom begins with awareness.",
    },
    reversed: {
      keywords: ["release", "breaking free", "detachment", "reclaiming power"],
      meaning: "You are ready to break free from what has held you. The chains are loosening.",
      advice: "Walk away. What seemed impossible to leave is easier than you thought.",
    },
    planet: "saturn",
    vedic_graha: "shani",
    element: "earth",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A tower struck by lightning, figures falling, flames emerging",
    id: 16,
    name_en: "The Tower",
    name_hi: "मीनार",
    vedic_name: "Pralay Stambha (The Pillar of Destruction)",
    vedic_parallel:
      "Like the churning of the ocean — destruction that releases both poison and nectar",
    upright: {
      keywords: ["sudden upheaval", "revelation", "chaos", "breakthrough", "awakening"],
      meaning: "A sudden collapse of what was built on false foundations. Painful but necessary.",
      advice: "Let it fall. What is true will survive the storm.",
    },
    reversed: {
      keywords: ["avoidance of disaster", "fear of change", "delayed upheaval"],
      meaning:
        "You sense the crack in the foundation but refuse to act. The fall comes regardless.",
      advice: "Address the weakness now, or the collapse will be worse later.",
    },
    planet: "mars",
    vedic_graha: "mangal",
    element: "fire",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A woman kneeling by water, pouring from two vessels, stars shining above",
    id: 17,
    name_en: "The Star",
    name_hi: "तारा",
    vedic_name: "Tara (The Guiding Light)",
    vedic_parallel: "Like Dhruv Tara — the steadfast star that guides travelers through darkness",
    upright: {
      keywords: ["hope", "faith", "renewal", "inspiration", "serenity"],
      meaning: "After the storm, clarity returns. Hope is not naive — it is earned.",
      advice: "Trust the process. You have survived the worst and light returns.",
    },
    reversed: {
      keywords: ["despair", "disconnection", "lack of faith", "hopelessness"],
      meaning: "Hope feels distant. You may be focusing on what was lost instead of what remains.",
      advice: "Look up. The stars are still there even when clouds cover them.",
    },
    planet: "uranus",
    vedic_graha: "rahu",
    element: "air",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A moon over a path between two towers, a dog and wolf howling",
    id: 18,
    name_en: "The Moon",
    name_hi: "चन्द्रमा",
    vedic_name: "Chandra Maya (Lunar Illusion)",
    vedic_parallel:
      "Like the moon's phases — reality shifts with perception, not everything is as it seems",
    upright: {
      keywords: ["illusion", "fear", "intuition", "the unconscious", "confusion"],
      meaning: "Things are not what they appear. Trust your intuition but verify your fears.",
      advice: "Wait for clarity. The full picture has not yet emerged.",
    },
    reversed: {
      keywords: ["release of fear", "clarity emerging", "overcoming confusion"],
      meaning: "The fog lifts. What confused you is becoming clear.",
      advice: "Act on the clarity that arrives. Do not return to old doubts.",
    },
    planet: "moon",
    vedic_graha: "chandra",
    element: "water",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A radiant sun above a child on a white horse, sunflowers blooming",
    id: 19,
    name_en: "The Sun",
    name_hi: "सूर्य",
    vedic_name: "Surya Prakash (Solar Radiance)",
    vedic_parallel:
      "Like Surya Devata illuminating the three worlds — truth that dispels all shadow",
    upright: {
      keywords: ["joy", "success", "vitality", "warmth", "clarity", "optimism"],
      meaning: "A time of clarity and joy. Success comes naturally when aligned with truth.",
      advice: "Step into the light. Your warmth uplifts everyone around you.",
    },
    reversed: {
      keywords: ["temporary setback", "lack of clarity", "dimmed joy"],
      meaning: "The light is there but temporarily obscured. Minor delays, not failure.",
      advice: "Be patient. The clouds pass and the sun returns stronger.",
    },
    planet: "sun",
    vedic_graha: "surya",
    element: "fire",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "An angel blowing a trumpet, figures rising from below with arms raised",
    id: 20,
    name_en: "Judgement",
    name_hi: "निर्णय",
    vedic_name: "Chitragupta Lekha (The Cosmic Reckoning)",
    vedic_parallel:
      "Like Chitragupta's ledger — the moment when all karmas are weighed and accounted",
    upright: {
      keywords: ["rebirth", "reckoning", "absolution", "calling", "inner voice"],
      meaning: "A call to rise. Past karmas are resolved and a higher purpose beckons.",
      advice: "Answer the call. This is the culmination of everything you have learned.",
    },
    reversed: {
      keywords: ["self-doubt", "refusal of calling", "harsh self-judgement"],
      meaning: "You are being too harsh on yourself, or refusing to hear your calling.",
      advice: "Forgive yourself. Growth requires accepting where you have been.",
    },
    planet: "pluto",
    vedic_graha: "ketu",
    element: "fire",
    arcana: "major",
    suit: null,
  },
  {
    image_description: "A dancing figure within a wreath, four creatures at the corners",
    id: 21,
    name_en: "The World",
    name_hi: "संसार",
    vedic_name: "Purna (The Complete)",
    vedic_parallel:
      "Like the Vishwarupa — the vision of totality where all cycles meet in completion",
    upright: {
      keywords: ["completion", "accomplishment", "integration", "wholeness", "travel"],
      meaning: "A cycle completes. You have arrived where you were meant to be.",
      advice: "Celebrate the completion. Then prepare for the next spiral.",
    },
    reversed: {
      keywords: ["incompleteness", "shortcuts", "delays", "unfulfillment"],
      meaning: "Something remains unfinished. The cycle cannot close until the lesson is learned.",
      advice: "Tie up loose ends. Completion requires attention to what you have avoided.",
    },
    planet: "saturn",
    vedic_graha: "shani",
    element: "earth",
    arcana: "major",
    suit: null,
  },
] as const satisfies readonly TarotReferenceCard[];
